import React, { Component } from 'react';
import VASSlider from 'react-surveyjs-vas-widget';
// import { Survey, CustomWidgetCollection } from 'survey-react';
import * as Survey from "survey-react";
import "./productdetail.css"
import _  from 'underscore';
import "survey-react/survey.css";
import Slider from "react-slick";
import  AuthService  from "../api/authentication.js";
import  Addinput from "./addinput"
import   Editdata from "./editdata"
import   Getdata  from "./inputdata"
import   Photo from "./photos"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import axios from 'axios';

const Auth = new AuthService();
var dataE = [
  {},
  {}, 
  {},
 
 
]
class ProductDetail  extends Component {


  constructor(props){
    super(props)
    this.state = {
        noerorrpage :  true,
        domain: 'https://uvune-listing.herokuapp.com',
        product:[],
        count : 0,
        disabled : false,
        photos : [],
        images: [],
        imageUrls : [],
        details:[],
        // categoeris:[],
        ifImage :false,
        showeditPage:false,
        categories:[],
        ifCatalog:false,
        ifCategory:false,
        getCategory:"",
        getusergate:[],
        productImage:[], 
        photoInput:dataE ,
        id : "",
        showCategory:false,
        ifSubmit : false,
        deleteOpsion:false,
        unit:[],
        selectUnit:"",
        groupCategory:[],
        isChecked: false,
     };
     
    
    }


    
componentDidMount(){
    this.props.noerorrpage(this.state.noerorrpage)
   
   
    const { match: { params } } = this.props;
    // console.log("params.userId",params.id, "params all", params, this.state.stock )
    this.setState({
     pageLoading : true,
     ifChart : false,
     id :params.id,
     loanData:true,
     unit:unitC,
     selectUnit:unitC[92]
     
   })
   const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
    //  body: JSON.stringify(data),
};
    fetch(this.state.domain+"/products/"+params.id, requestOptions )
    .then(res => res.json())
    .then(res => {
        //  console.log("error state product==----===----> ", res )
         
          if(res.product_images_url.length === 0){
            this.setState({
              details: res.quick_details,
              images:res.product_images_url,           
              loanData : false,
              product:res,
              selectUnit: res.measure,
              ifImage:false
            }) 
          }else{
            this.setState({
              details: res.quick_details,
              images:res.product_images_url,      
              selectUnit: res.measure, 
              loanData : false,
              product:res,
            
            }) 
          }
          
          fetch(this.state.domain+"/catalog/"+res.catalog, requestOptions )
            .then(res => res.json())
            .then(res => {
                  // console.log("category data ==----===----> ", res )
                    this.setState({
                      getusergate: res,
                      getCategory:res._id
                    
                    })  
              
            })

            fetch(this.state.domain+"/category-group?$limit=30/", requestOptions )
            .then(res => res.json())
            .then(res => {
                // console.log("error state this.state. getreview==----===----> ", res.data)
                    this.setState({
                      groupCategory : res.data,
                      // getfirstCate : res.data[0],
                      loanData : false,
                      // product:res,
                      
                    })  
            })
        
            // fetch(this.state.domain+"/category?$limit=40", requestOptions )
            // .then(res => res.json())
            // .then(res => {
            //       // console.log("error state this.state. getreview==----===----> ", res.data)
            //         this.setState({
            //           categoeris : res.data,
            //           // getfirstCate : res.data[0],
            //           loanData : false,
                      
            //         })  
              
            // })
          
         
            // this.GetCategory()
      
    })
  
}


selectImages = (event) => {
  event.preventDefault();
  let photo  = []
var images =     this.state.images
if(event.target.files.length  !== 0){
 this.setState({
   ifImage :true,
   editImage :true
 })
}else{
  this.setState({
    // ifImage :false
  })
}
var regex = new RegExp("([a-zA-Z0-9\s_\\.\-:])+(.jpg|.png|.gif)$");
for (var i = 0; i <  event.target.files.length && i < 5 ; i++) {
  
    photo[i] =  URL.createObjectURL(event.target.files.item(i))
    // console.log("data ===---->first file",event.target.files.item(i))
    if(event.target.files.item(i).size > 3309874) {
        toast("Sorry image is too bigger then 130 KB");
      //  console.log("datat size yes", event.target.files.item(i).size  )
    }else{
      // console.log("datat size no", event.target.files.item(i).size  )
      if (event.target.files.item(i).name.match(/\.(jpg|jpeg|png|gif)$/)) {
       
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files.item(i))
     
        reader.onload = (e) => {
          let imgDimWarning = false;
            //Initiate the JavaScript Image object.
            // console.log("error",e)
            var image = new Image();
           

            //Set the Base64 string return from FileReader as source.
            image.src = e.target.result;
                  
            //Validate the File Height and Width.
              // console.log("width", image.width, image.width)
               image.onload = ()=>{

                // console.log("width", image.width, image.height)
                if (image.height > 800 || image.width > 800) {
                      // alert("Height and Width must not exceed 100px.");
                      // console.log("data=====----->yes")
                       this.setState({imageError:false})
                       toast("Height and Width most not exceed 800px");
                  }else{
                      //  console.log("lolol--------> no", image)
                          this.setState({imageError:true})
                          
                         let images =  this.state.productImage
                          images.push(image.src)

                            this.setState({
                              // images: images,
                              productImage:images
                            })

                        // console.log("pushed images --------->", this.state.images);
                     
                  }
                 
              }

         }

      }else{
        toast("Image only jpg | jpeg | png | gif");
      }
    }
  }

}


uploadImages=(event) => {
  event.preventDefault();
    this.setState({
      loanData:true,
      loanData : true,
    })
   const uploaders = this.state.productImage.map(image => {
        const formData = new FormData();
        //  console.log('done image---->', image );
        formData.append('uri', image);
        formData.append('product_images', true);
        formData.append('product_id',  this.state.id);
        const options = {
            method: 'POST',
            headers: { 
                'content-type': 'multipart/form-data',
            'access-control-allow-origin': '*',
            'Authorization': Auth.getToken(), 
            },
        url:this.state.domain+"/upload-logo",
 };
   // Make an AJAX upload request using Axios
   return  axios.post(options.url, formData, options.headers)
   .then(response => {
      //  console.log("response", response.data.uri)
         const productImage  = this.state.images
         productImage.push(
                     response.data.uri
              )
         this.setState({
             images:productImage,
             productImage :[],
             ifImage:false
          //  imageUrls: [response.data.result, ...this.state.imageUrls ]
           });
          
       })
      
 });
 
   // Once all the files are uploaded 
     axios.all(uploaders).then(() => {
      //  this.forceUpdate(this.state.imageUrls)
      this.setState({
        loanData:false,
        editImage:false
      })
          // console.log('done');
     }).catch(err => alert(err.message));



}


showEdit=(e)=>{
  e.preventDefault()
   this.setState({
    showeditPage:true
   })
  //  console.log("data, trye", this.state.showeditPage)
}

hideEdit=(e)=>{
  e.preventDefault()
  this.setState({
    showeditPage:false
  })
}

newEdit=(data)=>{

  let detailss  = this.state.details
  // console.log("data",  detailss)
 var details  = detailss.filter((details , i)=>{
      if(i  == data.id){
          // console.log("------judge1 yes found i"   )
          // details.ID     =    data.id
          details.field    =    data.field
          details.value    =    data.value
          // console.log("------judge", details.field ," messid",  details.value  )
      }
      
      return details
   })
this.setState({
    details
  })
  

}


onDelete=(id)=>{
  // console.log("conselo==------>",id)
  // const  messages  =  dataView
   const fitleredmeassages = this.state.details.filter(( meassage ,i ) =>{
     return i !== id
   })
   
   this.setState({details:fitleredmeassages})
}

getdata=(data)=>{
  // event.preventDefault();
  // console.log("data ==------>",data);
  const  details  = this.state.details
       details.push({
          field : data.field,
          value : data.value,
          
      })
 this.setState({details})
}



updatedate=(event) => {
  // console.log("prodcu---->",this.state.details)
  event.preventDefault();
  this.setState({
   loanData : true,
   ifSubmit : true,
   loadingButton: true  
  }) 
  if(!this.state.isChecked) {
      const data ={
          name :this.name .value,
          max_price :this.maxprice.value,
          min_price :this.minprice.value,
          moq : this.moq.value,
          summary : this.summary.value,
          company_id : this.props.organizer._id,
          quick_details : this.state.details,
          category : this.props.organizer.category,
          catalog :  this.state.getCategory,
          measure:this.state.selectUnit,
          negotiable:false

      }
      //  console.log("data, rest--==--->", data)
      const requestOptions = {
          method: 'PATCH', 
          headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
           body: JSON.stringify(data),
      };
      // console.log(" requestOptions",  requestOptions)
      fetch(this.state.domain+"/products/"+ this.state.id, requestOptions)
      .then(res => res.json())
      .then((res)=>{
          //  console.log("data, rest--==--->", result)
          this.setState({
            product:res
          })
          if(res.code === "400"){
              // console.log("data, rest--==---> false", result)
              }else{
                const requestOptions1 = {
                  method: 'GET',
                  headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
                  //  body: JSON.stringify(data),
                };
                fetch(this.state.domain+"/catalog/"+this.state.getCategory, requestOptions1 )
                .then(result => result.json())
                .then(result => {
                      //  console.log("category data ==----===----> ", result )
                        this.setState({
                          getusergate: result,
                         
                          getCategory:result._id,
                          selectUnit: res.measure,
                          ifSubmit : false,
                          showeditPage:false,
                          loanData : false
                        
                        })  
                        toast("Updated !");
                })
            }
            
     })
     }else{
              const data ={
                name :this.name .value,
                // max_price :this.maxprice.value,
                // min_price :this.minprice.value,
                moq : this.moq.value,
                summary : this.summary.value,
                company_id : this.props.organizer._id,
                quick_details : this.state.details,
                category : this.props.organizer.category,
                catalog :  this.state.getCategory,
                // measure:this.state.selectUnit,
                negotiable:true

            }
            // console.log("data, rest--==--->", data)
            const requestOptions = {
                method: 'PATCH', 
                headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
                body: JSON.stringify(data),
            };
            //  console.log(" requestOptions",  requestOptions)
            fetch(this.state.domain+"/products/"+ this.state.id, requestOptions)
            .then(res => res.json())
            .then((res)=>{
                //  console.log("data, rest--==--->", result)
                this.setState({
                  product:res
                })
                if(res.code === "400"){
                    // console.log("data, rest--==---> false", result)
                    }else{
                      const requestOptions1 = {
                        method: 'GET',
                        headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
                        //  body: JSON.stringify(data),
                      };
                      fetch(this.state.domain+"/catalog/"+this.state.getCategory, requestOptions1 )
                      .then(result => result.json())
                      .then(result => {
                            //  console.log("category data ==----===----> ", result )
                              this.setState({
                                getusergate: result,
                                getCategory:result._id,
                                selectUnit: res.measure,
                                ifSubmit : false,
                                showeditPage:false,
                                loanData : false
                              
                              })  
                              toast("Updated !");
                      })
                  }
                  
          })

    }
}


GetCategory=()=>{
  setTimeout(function() {
    this.setState({
        erorrDiv : false
    })
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
      //  body: JSON.stringify(data),
  };
      fetch(this.state.domain+"/catalog?category="+ this.props.organizer.category, requestOptions )
      .then(result => result.json())
      .then(result => {
            // console.log("categoey ==----===----> ", result)
              this.setState({
                categoeris: result.data,
                loanData : false,
                // product:res
              }) 
      })
 
}.bind(this), 4000);

}

timeout() {
  //  console.log("data---====--==>",data)
   setTimeout(function() {
       this.setState({
           erorrDiv : false
       })
   //   console.log(this.state.noticeshow);
   }.bind(this), 4000);
}


// notify = () => toast("Wow so easy !");

Addcategory =(e)=>{
  e.preventDefault();
        
  this.setState({
      loadingcategory :false
  }) 
  
  const data ={
      // title:this.title.value,
      name  :this.name.value,
      category : this.props.organizer.category

   }
  //  console.log("data", data)
   const requestOptions = {
    method: 'POST', 
    headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
    body: JSON.stringify(data),
  };

  fetch(this.state.domain+"/catalog", requestOptions)
  .then(res => res.json())
  .then((res)=>{
    // console.log("data catalog===----->", res)
      if(res){
        const categories  = this.state.categoeris
        categories.push({
                  name: this.name.value,   
                  createdAt: res.createdAt,
                  _id : res._id
              })
           
      
          this.setState({
              loadingcategory:true, 
              showCategory:false,
              categoeris :categories
          })
      }else{
          this.setState({
              loadingcategory :false
          }) 
      }
      this.name.value = ""
      // this.description.value = ""
  })

}
productDelete=(e)=>{
  e.preventDefault();
  this.setState({
    saveupDate : false,
    loanData:true
   }) 


    const requestOptions = {
      method: 'DELETE', 
        headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
        // body: JSON.stringify(dataedit),
    };
    fetch(this.state.domain+"/products/"+ this.state.id, requestOptions)
    .then(res => res.json())
    .then((res)=>{
        if(res){
            // console.log("organizers============ ", result)
            this.setState({
                loadingTuition :false,
           
                saveupDate : false,
                errorend  : true,
                noticeMassage : " delete",
            }) 
            
            this.props.history.replace({
              pathname: '/products/',
              state: { notice: "true" , message:"Create Event" }
            })

        }else{
            this.setState({
                loadingTuition :true
            }) 
        }
       this. timeout()
    }).catch( (error) => {
        //  console.log("errro", error);
        this.setState({
            errorend  : true,
            noticeMassage : "Not delete",
        }) 
        this. timeout()
         
     });
}

deleteImage = (data) =>{
                           
  const fitleredmeassages = this.state.images.filter(( meassage ,i) =>{
    return i !== data
  })
 
     this.setState({images:fitleredmeassages})

      this.setState({
        loanData : true,
        ifSubmit : true,
        loadingButton: true  
      }) 
      
       const data1 ={
        
        product_images_url:fitleredmeassages
 
       }
      

       const requestOptions = {
           method: 'PATCH', 
           headers: {'Content-Type':'application/json', 'Access-Control-Allow-Origin': '*',    'Authorization': Auth.getToken(),  },
            body: JSON.stringify(data1),
       };
      //  console.log(" requestOptions",  requestOptions)
       fetch(this.state.domain+"/products/"+ this.state.id, requestOptions)
       .then(res => res.json())
       .then((res)=>{
            // console.log("data, rest--==--->", res)
           if(res.code === "400" || res.code  === "500"){
               
               }else{
                 toast("Photo deleted !");
                 if(res.product_images_url.length === 0) {
                  this.setState({
                    ifSubmit : false,
                    // ifImage:false,
                    showeditPage:false,
                    loanData : false,
                    //  images: res.product_images_url
                  })
                 }else{
                  this.setState({
                    // ifImage:false,
                    showeditPage:false,
                    loanData : false,
                  
                  })
                 }
                   
             }
             
      })
  

}

selectCategory = (e)=>{
  //  console.log("data--===------> category", e.target.value)
  this.setState({
     loanData:true,
    // getCategory: e.target.value
  })

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
    //  body: JSON.stringify(data),
  };

  fetch(this.state.domain+"/category?$limit=40&group_id="+e.target.value, requestOptions )
  .then(res => res.json())
  .then(res => {
        //  console.log("error state this.state. getreview==----===----> ", res.data)
         this.setState({

          categories:res.data,
          ifCategory:true,
          loanData:false
         }) 
  })

}
selectSubcategory = (e)=>{
  // console.log("data--===------> category", e.target.value)
 this.setState({
    loanData:true,
   // getCategory: e.target.value
 })

 const requestOptions = {
   method: 'GET',
   headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
   //  body: JSON.stringify(data),
 };

 fetch(this.state.domain+"/catalog?$limit=40&category="+e.target.value, requestOptions )
 .then(res => res.json())
 .then(res => {
      //  console.log("error state this.state. getreview==----===----> ", res.data)
        this.setState({

         catalog:res.data,
         ifCategory:true,
         loanData:false
        }) 
  })

}

deletePhoto = (data)=>{ 
  // console.log("datta----->", data)
  // const  messages  =  data
  const fitleredmeassages = this.state.productImage.filter(( meassage ,i) =>{
    // console.log("conselo==------> ooo",i)
    return i !== data
  })
    // console.log("data,----->update ",fitleredmeassages.length)
  this.setState({productImage:fitleredmeassages})

}

Showcategory= (e)=>{
  e.preventDefault()
  this.setState({
     showCategory: true
  })
}

closeFile = (e)=>{
  this.setState({
    editImage :false
  })
}
selectCatalog  = (e)=>{
// console.log("data--===------> category", e.target.value)
   this.setState({
       ifCatalog:true,
       getCategory: e.target.value
   })
}
Showcategory= (e)=>{
  e.preventDefault()
  this.setState({
     showCategory: true
  })
}


Unitselect = (e) =>{
  // console.log("data--===------> selectcurrency", e.target.value)
  this.setState({
    // ifCatalog:true,
    selectUnit: e.target.value
})
}


toggleChange = () => {
  this.setState({
    isChecked: !this.state.isChecked,
  });
  // console.log("checking--->1", this.state.isChecked)
}


cloesImage = ()=>{

  this.setState({
    ifImage:false
  })
 

}



  render() {
    //  console.log("prod", this.state.product)
    const settings = {
      // dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />
    };
    return (
            <div id="dashboard-wrapper " class="columns dashboard-cousom">
              <ToastContainer />
                {this.state.loanData?
                //   <Leader/>
                 <div class="pre-loader">
                <div class="loader"></div>
              </div> 
                  :
                  <div></div>
               }
              <div class="column"></div>
                  <div class="content column is-11">
              
                      {/* <!-- Breadcrumbs --> */}
                      <nav class="breadcrumbs">
                          {/* <button onClick={this.clickeme}>click</button> */}
                          <ul>
                              <li><a href="/">Home</a></li>
                              <li>Product Detail</li>
                          </ul>
                      </nav>
                      {/* <!-- /Breadcrumbs -->
              
                      <!-- Dashboard Wrapper --> */}
                      <div class="dashboard-wrapper">
                         <div className="company-product-image-click" style={{position:"relative",bottom:"10px"}}>
                                     <a class="button is-success is-small " href="/products">All product</a>
                          </div>
                                
                        <div className="Product-detail-body">
                        
                             {/* {
                              !this.state.ifImage? 
                              <div class="productdetail-wrapper">
                              </div>
                              :
                              } */}
                              <div class="productdetail-wrapper">
                                {
                                   this.state.ifImage? 
                                       <div>
                                           {
                                          this.state.productImage.map((url, i) => (
                                                    <div class="newproduct-a">
                                                        <a onClick={() => this.deletePhoto(i)}><i class="fas fa-trash-alt"  style={{color:"red",float:"right",position:"relative",top:"30px"}}></i></a>
                                                      <div  key={i} style={{position:"relative",top:"60px",marginLeft:"10px"}}>
                                                          <img src={url} className="" width="150"
                                                          alt="not available"/>
                                                      </div>
                                                    </div>
                                                ))
                                            }
                                         {
                                          this.state.photoInput.map((url, i) => {
                                              return( 
                                                <div class="newproduct-a" key={i}>
              
              
                                                    <div>
                                                      <input type="file" 
                                                      id="file" onChange={this.selectImages} multiple/>
                                                      <label for="file" >
                                                      <br/>
                                                      <br/>
                                                      <i class="fas fa-camera" style={{fontSize:"210%",textAlign:"center",position:"relative",bottom:"13px",color:"#00d1b2"}}></i> <br/>
                                                          
                                                      </label>
                                                    </div>
                                                  
                                              
                                                </div>
                                                )
                                            })
              
                                        }
                                       

                                       </div>
                                     :
                                     <div>
                                           {
                                              this.state.images.map((url, i) => (
                                                <div class="newproduct-a">
                                                  <a onClick={() => this.deleteImage(i)}><i class="fas fa-trash-alt"  style={{color:"red",float:"right",position:"relative",top:"30px"}}></i></a>
                                                  <div  key={i} style={{position:"relative",top:"60px",marginLeft:"10px"}}>
                                                      <img src={url} className="" width="150"
                                                      alt="not available"/>
                                                  </div>
                                                </div>
                                              ))
                                        }
                                        {
                                          this.state.photoInput.map((url, i) => {
                                              return( 
                                                <div class="newproduct-a" key={i}>
              
              
                                                    <div>
                                                      <input type="file" 
                                                      id="file" onChange={this.selectImages} multiple/>
                                                      <label for="file" >
                                                      <br/>
                                                      <br/>
                                                      <i class="fas fa-camera" style={{fontSize:"210%",textAlign:"center",position:"relative",bottom:"13px",color:"#00d1b2"}}></i> <br/>
                                                          
                                                      </label>
                                                    </div>
                                                  
                                              
                                                </div>
                                                )
                                            })
              
                                        }
                                  
                                     </div>
                                   
                                }
                           
                              </div>
                            
                              <div className="Product-detail-info">
                                {
                                 this.state.ifImage ?
                                 <div class="control product-control-button" style={{marginBottom:"20px",}}>
                                                            
                                  <button class="button is-primary is-rounded" onClick={this.uploadImages}  style={{width:"70%"}}
                                    >Upload</button>
                                    <button class="button  is-danger is-rounded" onClick={this.cloesImage} style={{marginLeft:"10px"}}>
                                      <i class="fas fa-times"></i></button>
                                </div>
                                
                                  :
                                  <div style={{marginBottom:"20px",height:"30px",width:"100%"}}>
                                      <a class="button is-danger  is-small" onClick={this.productDelete}>delete</a>
                                      {
                                        this.state.showeditPage ?
                                        <button class="button is-success  is-small" onClick={this.hideEdit} style={{position:"relative",left:"15px"}}><i class="fas fa-times" ></i></button>
                                        :
                                        <a class="button is-success  is-small" onClick={this.showEdit} style={{marginRight:"8px"}}>Edit</a>
                                      }
                                  </div>
                                }
                               
                                 
                               
                                {
                                  !this.state.showeditPage ?
                                  <div class="flex-card is-contact-info light-bordered card-overflow">
                                    <div class="product-detail-info-display">
                                                                                 
                                        <h4 class="info-heading">Product info</h4>

                                        <div >
                                        <table class="table compare-table">
                                    <tbody>
                                        <tr>
                                            <td class="feature-name"><small>Name: </small>  </td>
                                            <td > <p style={{textAlign:"left",position:"relative",right:"20px"}}>{this.state.product.name}</p> </td>
                                        </tr>
                                        <tr>
                                            <td class="feature-name"><small> Max price: </small>  </td>
                                            <td > <p style={{textAlign:"left",position:"relative",right:"20px"}}> {this.state.product.max_price}</p> </td>
                                        </tr>
                                        <tr>
                                            <td class="feature-name"><small>  Min price:  </small>  </td>
                                            <td > <p style={{textAlign:"left",position:"relative",right:"20px"}}> {this.state.product.min_price}</p> </td>
                                        </tr>
                                        <tr>
                                            <td class="feature-name"><small>   Quantity:  </small>  </td>
                                            <td > <p style={{textAlign:"left",position:"relative",right:"20px"}}>  {this.state.product.moq}</p> </td>
                                        </tr>
                                        <tr>
                                            <td class="feature-name"><small>  Unit:  </small>  </td>
                                            <td > <p style={{textAlign:"left",position:"relative",right:"20px"}}>{this.state.selectUnit}</p> </td>
                                        </tr>
                                        <tr>
                                            <td class="feature-name"><small>   Category:  </small>  </td>
                                            <td > <p style={{textAlign:"left",position:"relative",right:"20px"}}>  {this.state.getusergate.name}</p> </td>
                                        </tr>
                                        <tr>
                                            <td class="feature-name"><small>Summary: </small>  </td>
                                            <td > <p style={{textAlign:"left",position:"relative",right:"20px"}}>  {this.state.product.summary}</p> </td>
                                        </tr>
                                      
                                      
                                       </tbody>
                                   </table>
                                   <div className="new-product-review">
                                   {/* <button onClick={this.notify}>Notify !</button> */}
                                  {/* <ToastContainer /> */}
                                  <div className="new-product-review-sub">
                                    <div>
                                      
                                          <div>
                                             <p>Product Details</p> 
                                                {
                                                    this.state.details.length === 0 ?
                                                    <div></div>
                                                    :
                                                    <table class="table is-fullwidth">
                                                          <thead>
                                                                <tr>
                                                                    <th>Feature Name</th>
                                                                    <th>Description</th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                        <tbody>
                                                        {
                                                            this.state.details.map((message, i)=>{
                                                            return(
                                                                
                                                            <Editdata
                                                                key={i}
                                                                ID={i}
                                                                field={message.field}
                                                                value = {message.value}
                                                                onDelete={this.onDelete}
                                                                onEdit={this.newEdit}
                                                                editNewMessage={this.newEdit}
                                                              />
                                                                // <tr>
                                                                //     <td>  {message.field}</td>
                                                                //     <td> {message.value}</td>
                                                                // </tr>
                                                            
                                                            )
                                                            })
                                                        }       
                                            </tbody>
                                            </table>
                                             }
                                     
                                          </div>
                                      
                                    </div>
                                 
                                      
                                  </div>
                                 

                                  {/* <Addinput getdata={this.getdata}/> */}
                                  
                                  </div>

                                        </div>
                                                                                
                                     </div>
                                 </div>   
                               :
                               <div className="Product-detail-info">
                                {
                                  !this.state.showCategory? 
                                  <div class="flex-card is-contact-info light-bordered card-overflow">
                                <div className="Product-detail-edit">
                              <form onSubmit={this.updatedate}>
                              <div class="columns">
                               
                                {
                                    this.state.groupCategory?
                                    <div class="column is-one-third">
                                          <label>Category</label>
                                        {
                                            this.state.groupCategory.length > 0 ? (

                                              <div class="control" style={{width:"100%"}}>
                                                  <div className={this.state.groupCategory.length > 0 ?"select is-loadin":"select" }>
                                                    <select class="is-focused" style={{width:"300px"}} onChange={this.selectCategory} value={this.state.select}>
                                                    <option>       --- Select category  ---</option>
                                                      {
                                                        this.state.groupCategory.map(data => {
                                                              return  <option key={data._id} value={data._id}>{data.name}</option>
                                                          })
                                                      }
                                                    </select>
                                                  </div>
                                                </div>  
                                              )
                                            :
                                            <div></div>
                                          }
                                        </div>
                                        
                                        :
                                      <div>

                                      </div>
                                  }
                               
                                {
                                  this.state.categories?
                                        <div class="column ">
                                        
                                        {
                                            this.state.categories.length > 0 ? (
                                              <div>
                                                <label>Sub category</label>
                                                <div class="control">
                                                    <div className={this.state. categories.length > 0 ?"select is-loadin":"select" }>
                                                      <select class="is-focused" style={{width:"300px"}} onChange={this.selectSubcategory} value={this.state.select}>
                                                      <option>       --- Select category  ---</option>
                                                        {
                                                          this.state. categories.map(data => {
                                                                return  <option key={data._id} value={data._id}>{data.name}</option>
                                                            })
                                                        }
                                                      </select>
                                                    </div>
                                                  </div>
                                            
                                              </div>
                                                
                                              )
                                            :
                                            <div></div>
                                          }
                                        </div>
                                        
                                        :
                                      <div>

                                      </div>
                                    }
                                      {
                                        this.state.catalog?
                                              <div class="column ">
                                              
                                              {
                                                  this.state.catalog.length > 0 ? (
                                                  <div>
                                                      <label>Subcategory</label>
                                                    <div class="control">
                                                        <div class="select ">
                                                          <select class="is-focused"  style={{width:"300px"}} onChange={this.selectCatalog} value={this.state.select}>
                                                            <option>       --- Choose or write subcategory ---</option>
                                                            {
                                                              this.state.catalog.map(data => {
                                                                    return  <option key={data._id} value={data._id}>{data.name}</option>
                                                                })
                                                            }
                                                          </select>
                                                        </div>
                                                      </div>
                                                    </div>  
                                                  )
                                                  :
                                                  <div>
                                                    
                                                  </div>
                                                }
                                              </div>
                                              
                                              :
                                            <div></div>
                                         }
                                  
                                </div>
                               

                                <div class="field">
                                        <label class="label product-new-label">Name</label>
                                        <div class="control">
                                            <input class="input" type="text" defaultValue={this.state.product.name} ref={input =>this.name = input} placeholder="Product name" required/>
                                        </div>
                                </div>
                                <div className="productdetail-checkbox">
                                    <label>
                                          <input type="checkbox"
                                            checked={this.state.isChecked}
                                            onChange={this.toggleChange}
                                          />
                                          {
                                           !this.state.isChecked? 
                                              <small style={{position:"relative",bottom:"5px"}}>Negotiable</small>
                                            :
                                            <small style={{position:"relative",bottom:"5px"}}>Add Price</small> 
                                          }
                                        
                                    </label>

                                </div>
                                
                                {
                                   !this.state.isChecked? 
                                   <div class="field">
                                        <label class="label  product-new-label"> Min price</label>
                                        <div class="control">
                                            <input class="input" type="number" ref={input =>this.minprice = input} 
                                            defaultValue={this.state.product.min_price} placeholder="Amount" required />
                                        </div>
                                    </div>
                                   :
                                  ""
                                }
                                
                                {
                                   !this.state.isChecked? 
                                   <div class="field">
                                        <label class="label  product-new-label">  Max price</label>
                                        <div class="control">
                                            <input class="input" type="number" defaultValue={this.state.product.max_price
                                            } ref={input =>this.maxprice = input} placeholder="Amount" required/>
                                        </div>
                                   </div>
                                   :
                                   ""

                                }
                                
                                {
                                   !this.state.isChecked? 
                                    
                                        <div class="field">
                                        <label>Unit</label>
                          

                                          <div class="control">
                                              <div className={this.state.unit.length > 0 ?"select is-loadin":"select" }>
                                                <select class="is-focused" style={{width:"380px"}} onChange={this.Unitselect} value={this.state.selectUnit}>
                                                    {/* <option value={this.state.unit[0]}>  {this.state.unit[0]}    </option> */}
                                                  {
                                                    this.state.unit.map(data => {
                                                          return  <option key={data} value={data}>{data}</option>
                                                      })
                                                  }
                                                </select>
                                              </div>
                                            </div>    

                                        </div>
                                    :
                                       ""
                                   }
                                <br/>
                                
                                <div class="field">
                                        <label class="label  product-new-label">Quantity</label>
                                        <div class="control">
                                            <input class="input" type="number" ref={input =>this.moq = input}
                                             defaultValue={this.state.product.moq}placeholder="Min order" required/>
                                        </div>
                                </div>
                                
                                <div class="field">
                                        <label class="label  product-new-label"> Summary</label>
                                        <div class="control">
                                            <textarea class="input"  ref={input =>this.summary = input}
                                            defaultValue={this.state.product.summary} placeholder="Summary" required/>
                                        </div>
                                </div>
                                <br/>
                                <div className="new-product-review">
                                    <p>Product Details</p> 
                                   
                                      <div className="new-product-review-sub">
                                            {
                                                this.state.details.length === 0 ?
                                                <div></div>
                                                :
                                                <table class="table is-fullwidth">
                                                <thead>
                                                    <tr>
                                                        <th>Field</th>
                                                        <th>Value</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                            <tbody>
                                                    {
                                                        this.state.details.map((message, i)=>{
                                                        return(
                                                            
                                                        <Getdata
                                                            key={i}
                                                            ID={i}
                                                            field={message.field}
                                                            value = {message.value}
                                                            onDelete={this.onDelete}
                                                            onEdit={this.newEdit}
                                                            editNewMessage={this.newEdit}
                                                          />
                                                           )
                                                       })
                                                    }       
                                          </tbody>
                                        </table>
                                        }
                                       </div>
                                      
                               
                                 
                                   

                                    <Addinput getdata={this.getdata}/>
                                    
                                </div>

                                <br/>
                                <div className="Product-detail-edit-button">
                                  {
                                    this.state.ifSubmit ?
                                      <div className="level-item">
                                          <a className="button is-loading is-large is-light">Loading</a>
                                      </div>   
                                        
                                    :
                                      <button class="button is-primary is-rounded"value="Submit"  style={{width:"100%"}}>Submit</button>
                                  }
                               
                                </div>
                               
                                
                            
                                </form>
                                </div>


                                    </div>  
                                    :
                                    <div>
                                      <form  onSubmit={this.Addcategory}>
                                            <div >
                                                    <div className="phone-sub-body-form">  
                                              
                                                          <p className="control has-icons-left has-icons-right">
                                                                                        <input
                                                                                        // onChange={this.upDatenote}
                                                                                        ref={ input => this.name = input} 
                                                                                        defaultValue={ this.props.name}
                                                                                        className="input" type="tel" 
                                                                                        placeholder="Category name"/>
                                                                                        <span className="icon is-small is-left">
                                                                                        <i className="fas fa-tags">  </i> 
                                                                                        </span>
                                                              </p>
                                                          
                                                        </div>
                                                  
                                                      <input className="input" type="hidden" ref={input => this.id = input} defaultValue={ this.props.id} placeholder="More Information"  required/>  
                                                      <div className="cell-form1">
                                                        <button className="button is-small is-success button-style" >Save</button>
                                                        <a className="button is-small is-link " onClick={this.close}>Close</a>
                                                      </div>
                                                      <hr/>
                                                </div>   
                                            
                                        </form>
                                    </div>

                                }
                                  
                                  
                               

                                </div>

                                }
                                             
                              </div>
                                  
                           </div>
                              
                         </div>
                          
                       
                  </div>
                </div>
            )
        }
    }    
  export default  ProductDetail ;      



  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", position:"absolute",height:"30px",  }}
        onClick={onClick}
      />
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block",  position:"absolute",height:"30px",  }}
        onClick={onClick}
      />
    );
  }


  var unitC = [
  
    "Acre/Acres",
  "Ampere/Amperes",
  "Bag/Bags",
  "Barrel/Barrels",
  "Blade/Blades",
  "Box/Boxes",
  "Bushel/Bushels",
  "buyer/buyers",
  "Carat/Carats",
  "Carton/Cartons",
  "Case/Cases",
  "Centimeter/Centimeters",
  "Chain/Chains",
  "Combo/Combos",
  "Cubic Centimeter/Cubic Centimeters",
  "Cubic Foot/Cubic Feet",
  "Cubic Inch/Cubic Inches",
  "Cubic Meter/Cubic Meters",
  "Cubic Yard/Cubic Yards",
  "Day/Days",
  "Degrees Celsius",
  "Degrees Fahrenheit",
  "Dozen/Dozens",
  "Dram/Drams",
  "Fluid Ounce/Fluid Ounces",
  "Foot/Feet",
  "Forty-Foot Container",
  "Furlong/Furlongs",
  "Gallon/Gallons",
  "Gill/Gills",
  "Grain/Grains",
  "Gram/Grams",
  "Gross",
  "Hectare/Hectares",
  "Hertz",
  "Hour/Hours",
  "Inch/Inches",
  "Kiloampere/Kiloamperes",
  "Kilogram/Kilograms",
  "Kilohertz",
  "Kilometer/Kilometers",
  "Kiloohm/Kiloohms",
  "Kilovolt/Kilovolts",
  "Kilowatt/Kilowatts",
  "Liter/Liters",
  "Long Ton/Long Tons",
  "Megahertz",
  "Meter/Meters",
  "Metric Ton/Metric Tons",
  "Mile/Miles",
  "Milliampere/Milliamperes",
  "Milligram/Milligrams",
  "Millihertz",
  "Milliliter/Milliliters",
  "Millimeter/Millimeters",
  "Milliohm/Milliohms",
  "Millivolt/Millivolts",
  "Milliwatt/Milliwatts",
  "Month/Months",
  "Nautical Mile/Nautical Miles",
  "Ohm/Ohms",
  "Ounce/Ounces",
  "Pack/Packs",
  "Pair/Pairs",
  "Pallet/Pallets",
  "Parcel/Parcels",
  "Perch/Perches",
  "perimeter/square",
  "Piece/Pieces",
  "Pint/Pints",
  "Plant/Plants",
  "Pole/Poles",
  "Pound/Pounds",
  "Quart/Quarts",
  "Quarter/Quarters",
  "Quarter/Quarters",
  "Rod/Rods",
  "Roll/Rolls",
  "Set/Sets",
  "Sheet/Sheets",
  "Short Ton/Short Tons",
  "Square Centimeter/Square Centimeters",
  "Square Foot/Square Feet",
  "Square Inch/Square Inches",
  "Square Meter/Square Meters",
  "Square Mile/Square Miles",
  "Square Yard/Square Yards",
  "Stone/Stones",
  "Strand/Strands",
  "Ton/Tons",
  "Tonne/Tonnes",
  "Tray/Trays",
  "Twenty-Foot Container",
  "Unit/Units",
  "Volt/Volts",
  "Yard/Yards"
  
  ]


// WEBPACK FOOTER //
// ./src/component/company/productdetail.js